import { useMutation, useQueryClient } from 'react-query'
import { useSvcCrunchesContext } from '@dc-shared-web/providers/SvcCrunchesProvider'
import { useToast } from '@dc-shared-web/components/shadcn/use-toast'
import { moveProject } from '@dc-shared-web/hooks/api/project/moveProject'

export type MoveProjectParams = {
  parent_uuid: string
  office_uuid: string
  uuid: string
}

export const useMoveProject = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation(
    (mutationParams: MoveProjectParams) =>
      moveProject(apiClient, mutationParams),
    {
      onSuccess: async () => {
        await Promise.allSettled([
          queryClient.invalidateQueries({
            queryKey: ['projects'],
          }),
          queryClient.invalidateQueries({
            queryKey: ['folders', 'list'],
          }),
          queryClient.invalidateQueries(['FolderForMove']),
          queryClient.invalidateQueries(['FolderForMoveTree']),
          queryClient.invalidateQueries(['foldersList']),
        ])

        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error moving project',
          description: 'If the issue persists, please contact support.',
        })
        params?.onError?.()
      },
    }
  )
}
